import { JSXMapSerializer } from '@prismicio/react'
import tw from 'twin.macro'
import { renderStrikethrough } from './renderStrikethrough'

export const richTextComponents: JSXMapSerializer = {
  strong: ({ children }) => (
    <strong tw="uppercase font-object line-height[1]">{children}</strong>
  ),
  paragraph: ({ children }) => <p tw="mb-6">{children}</p>,
  heading1: ({ children }) => (
    <h1 css={[tw`mb-8 font-medium text-[30px] lg:text-[47px]`]}>{children}</h1>
  ),
  heading2: ({ children }) => (
    <h2 css={[tw`mb-6 font-medium text-[17px] lg:text-[28px]`]}>{children}</h2>
  ),
  heading3: ({ children }) => (
    <h3 css={[tw`mb-6 font-medium text-[17px] lg:text-[20px]`]}>{children}</h3>
  ),
  list: ({ children }) => (
    <ul css={[tw`list-disc list-outside pl-4 mb-6`]}>{children}</ul>
  ),
  oList: ({ children }) => (
    <ol css={[tw`list-disc list-outside pl-4 mb-6`]}>{children}</ol>
  ),
  listItem: ({ children }) => <li css={[tw`mb-2`]}>{children}</li>,
  oListItem: ({ children }) => <li>{children}</li>,
  em: ({ children }) => <i tw="italic">{children}</i>,
}

export const richTextStrongComponent: JSXMapSerializer = {
  strong: ({ children }) => (
    <strong tw="uppercase font-object line-height[1]">{children}</strong>
  ),
}

export const richTextListComponents: JSXMapSerializer = {
  list: ({ children }) => <ul tw="list-disc list-outside pl-6">{children}</ul>,
  oList: ({ children }) => <ol tw="list-disc list-outside pl-6">{children}</ol>,
  listItem: ({ children }) => <li>{children}</li>,
  oListItem: ({ children }) => <li>{children}</li>,
}

export const richTextStrikethroughComponent: JSXMapSerializer = {
  paragraph: ({ children }) => <p>{renderStrikethrough(children)}</p>,
  strong: ({ children }) => (
    <strong tw="uppercase font-object line-height[1]">{children}</strong>
  ),
}
